import { LocaleOverrideType, overrideLocale } from 'src/i18n/locale';

export function overrideLocaleFromAttribute(elem: Element) {
    const language = elem.getAttribute('language');
    if (language) {
        overrideLocale(language, LocaleOverrideType.ATTRIBUTE_OVERRIDE);
    }
}
